import { State } from "@/store/state";
import { Request } from "@/network/request";
import i18n from "@/i18n";
import toast from "@/plugins/toast";

export default class student {
  endPoint = "teacher/student/index";
  endPoint2 = "teacher/student";
  tableData = {
    data: [],
    showData: [],
    headers: {
      id: {
        name: "id",
        keys: ["id"],
      },
      firt_name: {
        name: "first_name",
        keys: ["first_name"],
      },
      last_name: {
        name: "last_name",
        keys: ["last_name"],
      },
    },
    meta: {
      total: 1,
      per_page: 1,
      current_page: 1,
    },
  };
  getState = new State();

  get(params) {
    let request = new Request({
      method: "get",
      endpoint: `/${this.endPoint}`,
      params: params,
      token: this.token,
    });

    this.getState.trigger(
      async () => {
        return await request.send();
      },
      {
        onSuccess: (value) => {
          this.tableData.data = value.data;
          this.tableData.meta = value.meta;
        },
        onError: (error) => {
          console.log(error);
        },
      }
    );
  }
  show(id) {
    let request = new Request({
      method: "get",
      endpoint: `/${this.endPoint2}/${id}`,
      token: this.token,
    });

    this.getState.trigger(
      async () => {
        return await request.send();
      },
      {
        onSuccess: (value) => {
          this.tableData.showData = value.data;
        },
        onError: (error) => {
          console.log(error);
        },
      }
    );
  }
}

export const Users = new student();
